import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-information-banner',
  templateUrl: './information-banner.component.html',
  styleUrls: ['./information-banner.component.scss']
})
export class InformationBannerComponent {
 @Input() messageKey = '';
  @Input() buttonKey = '';
  @Input() labelKey = 'shared.Important';

  @Input() theme: 'accent' | 'success' | 'warning' | 'info' = 'accent';

  @Input() showButton = true;

  @Output() handelOpenDialog = new EventEmitter<void>();

  onClick() {
    this.handelOpenDialog.emit();
  }

  get bgClass() {
    return `bg-${this.theme}-lighter`;
  }

  get textClass() {
    return `text-${this.theme}`;
  }

  get borderClass() {
    return `brd-${this.theme}-light`;
  }

  get badgeClass() {
    return `bg-${this.theme}`;
  }

  get buttonClass() {
    return `bg-${this.theme} brd-${this.theme}`;
  }
}
